import React from "react";
import {Chart as ChartJS, ArcElement, Tooltip, Legend} from "chart.js";
import {Pie} from "react-chartjs-2";
import styled from "styled-components";

ChartJS.register(ArcElement, Tooltip, Legend);

function toTitleCase(text: string) {
  if (typeof text !== "string") {
    console.error("Input must be a string.");
    return "";
  }
  return text
    .split(" ")
    .map((word) => {
      if (word.length === 0) {
        return "";
      }
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
}

const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: false,
    },
    labels: {
      render: "value",
      precision: 0,
      showZero: true,
      fontSize: 12,
      fontColor: "#fff",
      fontStyle: "normal",
      fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
      textShadow: true,
      shadowOffsetX: -5,
      shadowOffsetY: 5,
      shadowColor: "rgba(255,0,0,0.75)",
      arc: true,
      position: "default",
      overlap: true,
      showActualPercentages: true,
    },
  },
};

export const Piechart = ({orderInfo, title}: any) => {
  // Extract data from the new structure
  const statusBreakdown = orderInfo?.statusBreakdown || {};
  const idsArray = Object.keys(statusBreakdown);
  const countsArray = Object.values(statusBreakdown);
  const totalCount = orderInfo?.total || 0;

  const data = {
    labels: idsArray,
    datasets: [
      {
        label: "# of items", // Changed label to be more generic
        data: countsArray,
        backgroundColor: [
          "rgba(255, 99, 132, 1)", // Red
          "rgba(54, 162, 235, 1)", // Blue
          "rgba(255, 206, 86, 1)", // Yellow
          "rgba(75, 192, 192, 1)", // Green
          "rgba(153, 102, 255, 1)", // Purple
          "rgba(255, 159, 64, 1)", // Orange
          "rgba(100, 100, 100, 1)", // Grey
          "rgba(200, 50, 150, 1)", // Pinkish-purple
          "rgba(50, 200, 100, 1)", // Light Green
          "rgba(250, 150, 50, 1)", // Dark Orange
          "rgba(150, 50, 250, 1)", // Dark Purple
          "rgba(50, 150, 250, 1)", // Light Blue
          "rgba(255, 0, 0, 1)", // Pure Red
          "rgba(0, 255, 0, 1)", // Pure Green
          "rgba(0, 0, 255, 1)", // Pure Blue
          "rgba(255, 255, 0, 1)", // Pure Yellow
          "rgba(0, 255, 255, 1)", // Cyan
          "rgba(255, 0, 255, 1)", // Magenta
          "rgba(128, 0, 0, 1)", // Maroon
          "rgba(0, 128, 0, 1)", // Dark Green
          "rgba(0, 0, 128, 1)", // Navy
          "rgba(128, 128, 0, 1)", // Olive
          "rgba(128, 0, 128, 1)", // Dark Purple
          "rgba(0, 128, 128, 1)", // Teal
        ],
        borderColor: [
          "rgba(255, 99, 132, 1)",
          "rgba(54, 162, 235, 1)",
          "rgba(255, 206, 86, 1)",
          "rgba(75, 192, 192, 1)",
          "rgba(153, 102, 255, 1)",
          "rgba(255, 159, 64, 1)",
          "rgba(100, 100, 100, 1)",
          "rgba(200, 50, 150, 1)",
          "rgba(50, 200, 100, 1)",
          "rgba(250, 150, 50, 1)",
          "rgba(150, 50, 250, 1)",
          "rgba(50, 150, 250, 1)",
          "rgba(255, 0, 0, 1)",
          "rgba(0, 255, 0, 1)",
          "rgba(0, 0, 255, 1)",
          "rgba(255, 255, 0, 1)",
          "rgba(0, 255, 255, 1)",
          "rgba(255, 0, 255, 1)",
          "rgba(128, 0, 0, 1)",
          "rgba(0, 128, 0, 1)",
          "rgba(0, 0, 128, 1)",
          "rgba(128, 128, 0, 1)",
          "rgba(128, 0, 128, 1)",
          "rgba(0, 128, 128, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  return (
    <Wrapper>
      <Title>
        Total {title}: {totalCount}
      </Title>
      <div style={{height: "300px"}}>
        <Pie data={data} width={200} height={200} options={options} />
      </div>
      {/* <Legends>
        {idsArray.map((key, index) => {
          // Convert key to title case for display in legend, replacing underscores with spaces
          const displayKey = toTitleCase(key.replace(/_/g, " "));

          return (
            <div
              style={{display: "flex", alignItems: "center", gap: "5px"}}
              key={index}
            >
              <span
                style={{
                  background: data?.datasets[0]?.backgroundColor[index],
                }}
                className="circle"
              ></span>
              <span>{displayKey}</span>
            </div>
          );
        })}
      </Legends> */}
      {/* The commented out Info section remains as is */}
      {/* <Info>
      {
        orderInfo && orderInfo.map((fields: any, index:any) => {

            return (
              <div key={index} style={{background: Number(index) % 2 === 0  ? '#FFD9BC': '#FDECDF'}} >
              <p  className="circle">{fields._id || fields?.subscriptionName}</p>
              <p>{fields.count || fields?.numberOfSubscriptions}</p>
              </div>
            )
          })
        }
      </Info> */}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  /* height: 900px; */
`;

const Title = styled.h1`
  color: var(--e-ftd-orange, #fe7f1f);
  /* Small */
  font-family: Red Hat Display;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`;

const Legends = styled.div`
  margin: 20px auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  width: 300px;
  .circle {
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
`;
const Info = styled.div`
  width: 100%;
  margin: 20px auto;
  > div {
    margin: 0px auto;
    width: 300px;
    color: #000000;
    display: flex;
    align-items: center;
  }
  p {
    padding: 20px;
    width: 50%;
  }
  div > p:last-child {
    border-left: 1px solid #fcceaa;
  }
`;
